import { ElementLogic } from '../../../core/canvas-logic/base/element-logic';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ComponentFactory } from '../../../core/canvas-render/elements/component-factory';
import { InteractionEvent } from '@tencent/alloy-renderer';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { InterfaceShapeLinkFlagEvents } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/shape-link-flag-component/types';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { isSpecialActivity } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-utils';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';

export class CommonPlayerLogic extends ElementLogic {
    // 链接图标事件实例
    public flagEventsInstance: InterfaceShapeLinkFlagEvents;
    public constructor(factoryOptions: InterfaceFactoryOptions<IElementBaseModel>, component: ComponentFactory) {
        super(factoryOptions, component);
        this.component.wrapper.onMouseEnter(this.handleMouseEnter);
        this.component.wrapper.onMouseLeave(this.handleMouseLeave);
        if (browser?.isPc) {
            //  PC端绑定click事件
            this.component?.wrapper?.onClick(this.handleClick);
        } else {
            // 移动端touch，触发顺序touchStart → touchEnd → click
            // 由于touchStart和click的监听函数为同一个，为避免同一监听函数触发两次，移动端只绑定touchStart
            this.component?.wrapper?.onTouchEnd(this.handleClick);
        }
    }

    public handleClick = (e: InteractionEvent): void  => {
        // 设置动画触发器
        const slideClickFunc = this.factoryOptions?.handleSlideClick;
        if (slideClickFunc) {
            slideClickFunc(e, this.factoryOptions?.model);
        }

        // 设置链接跳转
        this.linkInPlayerJump(e);
    };

    protected getAppService(): ISlideBaseAppServices {
        return AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
    }

    private handleMouseEnter = (): void => {
        this.linkInPlayerHover(true);
    };

    private handleMouseLeave = (): void => {
        this.linkInPlayerHover(false);
    };

    // 点击设置链接的形状或图片，跳转
    private linkInPlayerJump = (e): boolean => {
        if (this.forbidLinkJump()) return false;
        const { model, getPlayerReduxStore } = this.factoryOptions;
        const { type, props } = model || {};
        if ([UIModelType.SHAPE, UIModelType.IMAGE].includes(type)) {
            const data = props.link?.href;
            const playerReduxStore = getPlayerReduxStore?.();
            if (data && playerReduxStore) {
                e.stopPropagation();
                this.getAppService().viewableServiceLayer.linkManager.openLinkInPlay(playerReduxStore, data);
                return true;
            }
        }
        return false;
    };

    // hover设置链接的形状或图片，显示title
    private linkInPlayerHover = (isShow): void | undefined => {
        if (this.forbidLinkHover()) return;
        const { model } = this.factoryOptions;
        const { type, props } = model || {};
        if ([UIModelType.SHAPE, UIModelType.IMAGE].includes(type) && props.link?.href) {
            const { tooltip, href } = this.getAppService().viewableServiceLayer.linkManager.getLinkInfo(props);
            const { worldBounds } = this.component?.wrapper || {};
            if (worldBounds) {
                const left = (worldBounds.maxX + worldBounds.minX) / 2;
                const top = worldBounds.maxY;
                eventBus.emit(EventKeys.UPDATE_TITLE_SHOW_STATE, {
                    visible: isShow,
                    containerOffsetX: left,
                    containerOffsetY: top,
                    title: tooltip || href,
                });
            }
        }
    };

    // 禁止link hover时显示title
    private forbidLinkHover = (): boolean => isSpecialActivity;

    // 禁止点击link时跳转
    private forbidLinkJump = (): boolean => isSpecialActivity && !this.component?.getWrapper()?.alpha;
}
